 // Footer Menu
 export function footerMenu() {
  // Each all footer menu items
  [...document.querySelectorAll('.page-footer__block-heading')]?.forEach(menuItem => {
    // Check if there's a dropdown menu associated with the current menuItem
    const dropdownMenu = menuItem.nextElementSibling;
    if (dropdownMenu && dropdownMenu.matches('.wp-block-navigation')) {
      menuItem.classList.add('has-dropdown');

      // Menu item toggle class on click
      menuItem.addEventListener('touchstart', function() {
        this.classList.toggle('open');
      });
    }
  });
}